import gql from 'graphql-tag';

export default gql`
  mutation unsubscribeSubscriptionMutation($codeForUnsubscribe: String) {
    unsubscribeSubscriptionMutation(codeForUnsubscribe: $codeForUnsubscribe) {
      title
      message
    }
  }
`;
